// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2iEXi","buttons":"styles_buttons__gh4fV"};